import { render, staticRenderFns } from "./pan.vue?vue&type=template&id=d6ed5df6&"
import script from "./pan.vue?vue&type=script&lang=js&"
export * from "./pan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports